import OfferTabs from "./offer-tabs";

export default OfferTabs;